import React, { Fragment, useEffect, useState } from 'react';
import axios from "axios";
import SpeechProduct from './SpeechProduct';
import { useSpeechContext } from "@speechly/react-client";
import {
  PushToTalkButton,
  BigTranscript,
  IntroPopup
} from "@speechly/react-ui";

const apiURL = process.env.REACT_APP_API_URL;

//if object array needed
let arrayids = [];

const FetchAndSpeech = () => {
  const { segment } = useSpeechContext();
  const [products, setProducts] = useState([]);
  const [voiceCat, setVoiceCat] = useState('');
  const [voiceProName, setVoiceProName] = useState('');
  // eslint-disable-next-line
  const [loading, setLoading] = useState(false);

  //output check
  console.log('top name:', voiceProName.toLowerCase());
  console.log('top category:', voiceCat.toLowerCase());

  //voice and query filter
  const filterFunc = (data) => {
    return data.filter(product =>
      product.pName.toLowerCase().includes(voiceProName.toLowerCase()) &&
      product.pCategory.cName.toLowerCase().includes(voiceCat.toLowerCase())

    );
  };

  useEffect(() => {
    getProducts();
    // eslint-disable-next-line
  }, []);


  useEffect(() => {

    if (segment) {
      if (segment.entities) {
        //segement.entities is a array which is from speechly app
        segment.entities.forEach(entity => {
          //if customer search by product
          if (entity.type === "product" && entity.value) {
            setVoiceProName(entity.value);
            console.log('get product type:', entity.type);
            console.log('get product voice:', entity.value);
          } else {
            console.log('product search not working')
          }
          //if customer search by category
          if (entity.type === "brand" && entity.value) {
            setVoiceCat(entity.value);
            console.log('get brnd type:', entity.type);
            console.log('get brand voice:', entity.value);
          } else {
            console.log('brand search not working')
          }
          //To get all product list store empty value
          if (entity.type === "clear" || entity.value === "restart") {
            setVoiceProName('')
            setVoiceCat('')
          } else {
            console.log('clear not working')
          }
        });
      }
      if (segment.isFinal) {
        console.log('✅', segment.entities);
      }
    }
    // eslint-disable-next-line
  }, [segment]);


  //if fecthing array is needed for each product
  products.forEach(d => {
    arrayids.push(d)
  }, []);

  const getProducts = async () => {
    try {
      //get data from api url
      const res = await axios.get(`${apiURL}/api/product/all-product`);
      //and store to useState
      setProducts(res.data.Products);
      //if loading it will store true
      setLoading(true);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <Fragment>
      {/* show voice text is from speechly libraries*/}
      <BigTranscript placement="top" />
      {/* intro with button is from speechly libraries*/}
      <PushToTalkButton placement="bottom" captureKey=" " powerOn="auto" />
      <IntroPopup />
      <section className="mt-4 m-4 md:mx-8 md:my-6 grid grid-cols-2 lg:grid-cols-4">
      <SpeechProduct data={filterFunc(products)} />
      </section>
    </Fragment>
  )
}

export default FetchAndSpeech;